<template>
  <div class="mc-rec-ord-summary">
    <div class="mc-rec-ord-summary__metrics">
      <div class="mc-rec-ord-summary__metric">
        <span class="mc-rec-ord-summary__num">{{ recommendedCount }}</span>
        <span class="mc-rec-ord-summary__lbl">recomendados</span>
      </div>
      <div class="mc-rec-ord-summary__metric">
        <span class="mc-rec-ord-summary__num">{{ purchasedCount }}</span>
        <span class="mc-rec-ord-summary__lbl">comprados</span>
      </div>
      <div class="mc-rec-ord-summary__metric mc-rec-ord-summary__metric--accent">
        <span class="mc-rec-ord-summary__num">{{ convertedCount }}</span>
        <span class="mc-rec-ord-summary__lbl">convertidos</span>
      </div>
    </div>
    <div v-if="conversionRateLabel" class="mc-rec-ord-summary__rate">
      {{ conversionRateLabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendationOrderSummary',
  props: {
    recommendedCount: { type: Number, default: 0 },
    purchasedCount: { type: Number, default: 0 },
    convertedCount: { type: Number, default: 0 },
    conversionRateLabel: { type: String, default: null },
  },
}
</script>
